import { getWwoofStatusClass } from '../../utils/wwoofTheme';

const ICON_CLASS = 'wwoof-meta-icon';

function WwoofMetaIcon({ name }) {
    switch (name) {
        case 'people':
            return (
                <svg className={ICON_CLASS} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <circle cx="9" cy="8" r="3" />
                    <path d="M3.5 20v-1.2A4.8 4.8 0 0 1 8.3 14h1.4a4.8 4.8 0 0 1 4.8 4.8V20" />
                    <path d="M16 5.5a3 3 0 0 1 0 5.8" />
                    <path d="M17 14.2a4.8 4.8 0 0 1 4 4.8V20" />
                </svg>
            );
        case 'calendar':
            return (
                <svg className={ICON_CLASS} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="3" y="4.5" width="18" height="17" rx="2" />
                    <path d="M16 2.5v4M8 2.5v4M3 9.5h18" />
                    <path d="M8 13h.01M12 13h.01M16 13h.01M8 17h.01M12 17h.01" />
                </svg>
            );
        case 'pin':
            return (
                <svg className={ICON_CLASS} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M20 10.5c0 5.3-8 11-8 11s-8-5.7-8-11a8 8 0 1 1 16 0Z" />
                    <circle cx="12" cy="10.5" r="2.7" />
                </svg>
            );
        case 'user':
            return (
                <svg className={ICON_CLASS} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <circle cx="12" cy="8" r="3.4" />
                    <path d="M5.5 20a6.5 6.5 0 0 1 13 0" />
                </svg>
            );
        case 'venus':
            return (
                <svg className={ICON_CLASS} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <circle cx="12" cy="8.5" r="4.5" />
                    <path d="M12 13v8M9 18h6M15.2 5.3 18 2.5" />
                </svg>
            );
        case 'mars':
            return (
                <svg className={ICON_CLASS} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <circle cx="10" cy="14" r="4.5" />
                    <path d="m13.2 10.8 7-7M15.5 4H20v4.5" />
                </svg>
            );
        default:
            return null;
    }
}

export function WwoofCardMeta({ items, variant }) {
    if (!items || items.length === 0) {
        return null;
    }

    return (
        <div className={`wwoof-card-meta${variant === 'wwwoofer' ? ' wwwofer-meta' : ''}`}>
            {items.map((item) => (
                <div
                    key={`${item.id}-${item.text}`}
                    className={`wwoof-meta-item wwoof-meta-item-${item.label || item.id}`}
                    data-field-id={item.id}
                >
                    <WwoofMetaIcon name={item.icon} />
                    <span className="wwoof-meta-value">{item.text}</span>
                </div>
            ))}
        </div>
    );
}

export function WwoofStatusBadge({ status }) {
    if (!status) {
        return null;
    }

    return (
        <div className={`wwoof-status-badge ${getWwoofStatusClass(status)}`}>
            {status}
        </div>
    );
}

export default WwoofCardMeta;
